// Music for the game. Create one engine at start-up, feed it state and events, mount
// <MusicControl music={music} /> (./MusicControl.tsx) somewhere in the HUD.
//
//   const music = createMusic();
//   music.setState({ screen: 'game' });      // loading | leader-select | game | sandbox
//   music.setState({ atWar: true });         // peace bed <-> tension bed
//   music.cue('turn-advanced');              // war-declared | deal-signed | turn-advanced | victory-opened
//
// Sound starts on the first click or key press; before that the calls are remembered, not played.

import { createEngine } from './engine.ts';
import type { Music } from './types.ts';
import { browserDeps } from './web.ts';

export interface MusicOptions {
  /** Where the site is served from; audio is read from <baseUrl>audio/. Defaults to Vite's base. */
  baseUrl?: string;
}

export function createMusic(options: MusicOptions = {}): Music {
  return createEngine(browserDeps(options.baseUrl ?? import.meta.env.BASE_URL));
}

export type {
  BedCue,
  Channel,
  CueId,
  Music,
  MusicEvent,
  MusicSnapshot,
  MusicState,
  MusicStatus,
  MuteMode,
  Screen,
  Settings,
  Source,
  StingCue,
} from './types.ts';
